import { ComponentRef, inject, Injectable, signal, OnDestroy } from '@angular/core';
import { LogVisualizerComponent } from '../../components/log-visualizer/log-visualizer.component';
import { GlobalFVComponent } from '../../interface/global-component.model';
import { GlobalDynamicFvModalLoaderService } from '../global-dynamic-fv-modal-loader/global-dynamic-fv-modal-loader.service';
import { formatDate } from '@angular/common';
import {environment} from 'src/environments/environment';
import {ENVIRONMENT_NAME} from 'src/environments/environment-name.enum';

@Injectable({
  providedIn: 'root',
})
export class GlobalLogVisualizerService extends GlobalFVComponent<LogVisualizerComponent> implements OnDestroy {
  private globalDynamicFvModalLoaderService = inject(
    GlobalDynamicFvModalLoaderService
  );

  modalRef = signal<ComponentRef<LogVisualizerComponent> | null>(null);

  currentLogs = signal<
    { timestamp: string; message: string; customData: string }[]
  >([]);

  addLog(message: string, customData?: unknown): void {
    if (environment.name === ENVIRONMENT_NAME.alpha) {
      return;
    }

    if (this.currentLogs().length > 1000) {
      this.currentLogs.set([]);
    }

    const date = formatDate(new Date(), 'HH:mm:ss', 'es-ES');
    const logs: {
      timestamp: string;
      message: string;
      customData: string;
    }[] = this.currentLogs();

    logs.push({
      timestamp: date,
      message: message,
      customData: JSON.stringify(customData)?.trim(),
    });

    this.currentLogs.set(logs);
    this.modalRef()?.instance.updateLogs();
  }

  open(): void {
    if (this.modalRef()) {
      this.close();
    }

    const modalRef = this.globalDynamicFvModalLoaderService.openModal(
      LogVisualizerComponent
    );

    this.modalRef.set(modalRef);
  }

  close(): void {
    if (this.currentLogs().length > 1000) {
      this.currentLogs.set([]);
    }

    if (this.modalRef()) {
      this.globalDynamicFvModalLoaderService.closeModal(
        this.modalRef() as ComponentRef<LogVisualizerComponent>
      );
      this.modalRef.set(null);
    }
  }

  /**
   * Cleanup resources when service is destroyed
   * Closes any open modals and cleans up references
   */
  ngOnDestroy(): void {
    if (this.modalRef()) {
      this.close();
    }
    
    this.currentLogs.set([]);
  }
}
